import React, {Component} from 'react'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import AddIcon from '@material-ui/icons/AddCircle'

import PaperBlock from "../../../../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * 	title - заголовок
 * 	shop - выбранные магазины
 * 		
 * 	onSelectShopClick()
 */

class ShopPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex", flexDirection: "column", width: "auto"}}>

			<div style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>

				<Typography 
					style = {{flex: "1 1 auto"}}
					variant = "body1" 
					color = {this.props.shop ? "textPrimary" : "textSecondary"}
				>
					{this.props.shop ? this.props.shop.name : "Магазин не указан"}
				</Typography>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSelectShopClick === "function") {
							this.props.onSelectShopClick()
						}
					}}
				>
					<AddIcon className = {this.props.classes.AddIcon}/>
					Выбрать магазин
				</Button>

			</div>

		</PaperBlock>
		
	}

}

export default withStyles(theme => ({
	chip: {
		margin: theme.spacing.unit
	},
	AddIcon: {
		marginRight: theme.spacing.unit
	}
}))(ShopPanel)
